const TerminationModule = {
  namespaced: true,
  state: {
    terminationResponse: null
  },
  actions: {},
  mutations: {
    saveTerminationResponse (state, response) {
      state.terminationResponse = response
    },
    resetTerminationState (state) {
      state.terminationResponse = null
    }
  },
  getters: {
    terminationResponse: state => {
      return state.terminationResponse
    }
  }
}

export {
  TerminationModule
}
